export class WorldMapTooltip {
	constructor(element) {
		this.frame = element.querySelector(".global-presence__frame");
		this.tip = document.createElement("div");
		this.tip.className = "global-presence__tooltip";
		this.tip.id = `${element.id}-flag-tooltip`;
		this.tip.setAttribute("role", "tooltip");
		this.tip.hidden = true;
		this.frame.append(this.tip);
		window.addEventListener("scroll", () => this.hide(), { passive: true });
	}

	bind(flag, country) {
		flag.setAttribute("role", "img");
		flag.setAttribute("aria-label", country);
		flag.setAttribute("aria-describedby", this.tip.id);
		flag.setAttribute("tabindex", "-1");
		flag.addEventListener("pointerenter", () => this.show(flag, country));
		flag.addEventListener("focus", () => this.show(flag, country));
		flag.addEventListener("pointerleave", () => this.hide());
		flag.addEventListener("blur", () => this.hide());
		flag.addEventListener("keydown", (event) => { if (event.key === "Escape") this.hide(); });
	}

	show(flag, country) {
		if (!flag.closest(".is-flag-visible")) return;
		this.tip.textContent = country;
		this.tip.hidden = false;
		const bounds = flag.getBoundingClientRect();
		const frame = this.frame.getBoundingClientRect();
		const x = Math.max(12, Math.min(frame.width - this.tip.offsetWidth - 12,
			bounds.left - frame.left + (bounds.width - this.tip.offsetWidth) / 2));
		const y = bounds.bottom - frame.top + this.tip.offsetHeight + 12 > frame.height
			? bounds.top - frame.top - this.tip.offsetHeight - 10 : bounds.bottom - frame.top + 10;
		this.tip.style.left = `${x}px`;
		this.tip.style.top = `${Math.max(12, y)}px`;
	}

	hide() {
		this.tip.hidden = true;
	}
}
